import React from "react";
import {
  Button,
  FlexRowBetween,
  Input,
  Label,
  PopupForm,
} from "../../common/Style";
import { setCallsRecord } from "../../../store/reducers/dataReducer";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { CFV } from "../../common/others/Functions";

const SetCallsRecord = ({ stats, init }) => {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    const body = { ...data, ...stats };
    dispatch(setCallsRecord(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success(
          <div>
            <div>{`נוספו ${res.payload.data}₪ ליתרה`}</div>
            <div>{`נותרו ${stats.negC} שיחות שלא נענו`}</div>
            {(data.talName == "נופר גוזלן" || data.talName == "שירן כהן") &&
              parseInt(stats.number) == 1 && (
                <div>{`התבצעו שיחות ל ${
                  parseInt(stats.negC) + parseInt(stats.posC)
                } רשומות`}</div>
              )}
          </div>
        );
        init();
      } else toast.error(res.payload?.error);
    });
  };
  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <Label>שם משתמש</Label>
        <Input
          type="text"
          {...register("talName", {
            required: true,
            minLength: 2,
            maxLength: 50,
          })}
        />
        {CFV("talName", "בין 2 ל 50 תווים", errors)}
        <FlexRowBetween style={{ marginTop: "50px" }}>
          <Button style={{ width: "100%" }}>שליחה</Button>
        </FlexRowBetween>
      </div>
    </PopupForm>
  );
};

export default SetCallsRecord;
